import type { TranslationKey } from '~/shared/internationalization/translation';

const prefix = 'pages.job-architecture-v2.profile-tasks.automation' as const;

export const automationAssessmentTranslationKeys = {
    aiNotice: `${prefix}.ai-notice`,
    businessImpact: `${prefix}.business-impact`,
    capability: `${prefix}.capability`,
    capabilityDescription: `${prefix}.capability-description`,
    capabilityFullySpecified: `${prefix}.capability-fully-specified`,
    capabilityNeedsJudgment: `${prefix}.capability-needs-judgment`,
    capabilityNotWritable: `${prefix}.capability-not-writable`,
    capabilityRoutine: `${prefix}.capability-routine`,
    detailBreadcrumb: `${prefix}.detail-breadcrumb`,
    detailTitle: `${prefix}.detail-title`,
    digitalShare: `${prefix}.digital-share`,
    digitalShareDescription: `${prefix}.digital-share-description`,
    effortShare: `${prefix}.effort-share`,
    effortShareDescription: `${prefix}.effort-share-description`,
    factors: `${prefix}.factors`,
    formula: `${prefix}.formula`,
    mandated: `${prefix}.mandated`,
    mandatedNoDescription: `${prefix}.mandated-no-description`,
    mandatedYesDescription: `${prefix}.mandated-yes-description`,
    no: `${prefix}.no`,
    notAssessed: `${prefix}.not-assessed`,
    openDetails: `${prefix}.open-details`,
    openStep: `${prefix}.open-step`,
    passesWithoutReview: `${prefix}.passes-without-review`,
    passesWithoutReviewDescription: `${prefix}.passes-without-review-description`,
    people: `${prefix}.people`,
    peopleDescription: `${prefix}.people-description`,
    pending: `${prefix}.pending`,
    percent: `${prefix}.percent`,
    stepBreadcrumb: `${prefix}.step-breadcrumb`,
    title: `${prefix}.title`,
    yes: `${prefix}.yes`,
} as const satisfies Record<string, TranslationKey>;

const impactPrefix = `${prefix}.impact` as const;

/** The business impact tile: the drivers, their levels and how they add up to the task's value. */
export const businessImpactTranslationKeys = {
    addsUp: `${impactPrefix}.adds-up`,
    compliance: `${impactPrefix}.compliance`,
    complianceHint: `${impactPrefix}.compliance-hint`,
    cost: `${impactPrefix}.cost`,
    costHint: `${impactPrefix}.cost-hint`,
    drivers: `${impactPrefix}.drivers`,
    errorCost: `${impactPrefix}.error-cost`,
    furtherHit: `${impactPrefix}.further-hit`,
    levelCritical: `${impactPrefix}.level-critical`,
    levelMinor: `${impactPrefix}.level-minor`,
    levelNone: `${impactPrefix}.level-none`,
    levelNoticeable: `${impactPrefix}.level-noticeable`,
    levelSignificant: `${impactPrefix}.level-significant`,
    noHit: `${impactPrefix}.no-hit`,
    notRated: `${impactPrefix}.not-rated`,
    open: `${impactPrefix}.open`,
    peopleServed: `${impactPrefix}.people-served`,
    peopleServedHint: `${impactPrefix}.people-served-hint`,
    revenue: `${impactPrefix}.revenue`,
    revenueHint: `${impactPrefix}.revenue-hint`,
    risk: `${impactPrefix}.risk`,
    riskHint: `${impactPrefix}.risk-hint`,
    strongestHit: `${impactPrefix}.strongest-hit`,
} as const satisfies Record<string, TranslationKey>;

const recommendationPrefix = `${prefix}.recommendation` as const;

export const automationRecommendationTranslationKeys = {
    automatable: `${recommendationPrefix}.automatable`,
    automatableValue: `${recommendationPrefix}.automatable-value`,
    automatedToday: `${recommendationPrefix}.automated-today`,
    automatedTodayValue: `${recommendationPrefix}.automated-today-value`,
    autonomy: `${recommendationPrefix}.autonomy`,
    autonomyValue: `${recommendationPrefix}.autonomy-value`,
    buildPlan: `${recommendationPrefix}.build-plan`,
    businessFunction: `${recommendationPrefix}.business-function`,
    complexity: `${recommendationPrefix}.complexity`,
    complexityHigh: `${recommendationPrefix}.complexity-high`,
    complexityHighDescription: `${recommendationPrefix}.complexity-high-description`,
    complexityHighLabel: `${recommendationPrefix}.complexity-high-label`,
    complexityLow: `${recommendationPrefix}.complexity-low`,
    complexityLowDescription: `${recommendationPrefix}.complexity-low-description`,
    complexityLowLabel: `${recommendationPrefix}.complexity-low-label`,
    complexityMedium: `${recommendationPrefix}.complexity-medium`,
    complexityMediumDescription: `${recommendationPrefix}.complexity-medium-description`,
    complexityMediumLabel: `${recommendationPrefix}.complexity-medium-label`,
    copy: `${recommendationPrefix}.copy`,
    download: `${recommendationPrefix}.download`,
    fit: `${recommendationPrefix}.fit`,
    fitLabel: `${recommendationPrefix}.fit-label`,
    hideBuildPlan: `${recommendationPrefix}.hide-build-plan`,
    match: `${recommendationPrefix}.match`,
    pending: `${recommendationPrefix}.pending`,
    products: `${recommendationPrefix}.products`,
    recipePreview: `${recommendationPrefix}.recipe-preview`,
    recipeSource: `${recommendationPrefix}.recipe-source`,
    recipeView: `${recommendationPrefix}.recipe-view`,
    sectionTitle: `${recommendationPrefix}.section-title`,
    showBuildPlan: `${recommendationPrefix}.show-build-plan`,
    title: `${recommendationPrefix}.title`,
    triggerDetail: `${recommendationPrefix}.trigger-detail`,
    triggerEvent: `${recommendationPrefix}.trigger-event`,
    triggerEventDescription: `${recommendationPrefix}.trigger-event-description`,
    triggerManual: `${recommendationPrefix}.trigger-manual`,
    triggerManualDescription: `${recommendationPrefix}.trigger-manual-description`,
    triggerSchedule: `${recommendationPrefix}.trigger-schedule`,
    triggerScheduleDescription: `${recommendationPrefix}.trigger-schedule-description`,
} as const satisfies Record<string, TranslationKey>;
